import {PinProtect} from '~/features/Auth/PinProtect';
import {ResetTeenInvite} from '~/features/ParentPay';

export const ResetTeenInviteScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <ResetTeenInvite />
      </PinProtect>
    </div>
  );
};
